import { LAKH, CRORE } from "../model/types.ts";
import { NPS_UNLOCK_AGE } from "../lib/otherSavings.ts";
import type { OtherSavings } from "../lib/otherSavings.ts";
import { NumberField } from "./NumberField.tsx";

const LIMIT = { min: 0, max: 500 * CRORE, step: LAKH, hint: "₹0 to ₹500 cr" };

const LINES: { key: keyof OtherSavings; label: string; hint: string }[] = [
  { key: "indianMarket", label: "Indian mutual funds and shares", hint: "Current market value." },
  { key: "deposits", label: "Fixed deposits, bonds and bank balances", hint: "In India." },
  { key: "providentFunds", label: "PPF and EPF", hint: "Current balance." },
  { key: "nps", label: "NPS", hint: "" },
  { key: "abroad", label: "Savings in other countries", hint: "Outside the US and India, converted to rupees." },
  { key: "other", label: "Anything else you would invest", hint: "Not the home you will live in." },
];

/** "Other savings" fieldset in the calculator panel. */
export function OtherSavingsFields({
  value,
  onChange,
  ageAtRetirement,
}: {
  value: OtherSavings;
  onChange: (next: OtherSavings) => void;
  ageAtRetirement: number;
}) {
  return (
    <fieldset>
      <legend>Other savings, today's value</legend>
      <p className="fieldset-note">
        Added to your US savings when comparing with the corpus. Enter today's value before tax —
        Indian gains are taxed when you sell, so what you can actually spend is a little lower. Kept
        in this browser only, not in the share link.
      </p>
      {LINES.map((l) => (
        <NumberField
          key={l.key}
          label={l.label}
          unit="inr"
          value={value[l.key]}
          limit={LIMIT}
          hint={
            l.key === "nps"
              ? ageAtRetirement >= NPS_UNLOCK_AGE
                ? "Counted: you retire at 60 or later."
                : `Shown but not counted: NPS is largely locked until ${NPS_UNLOCK_AGE}, and you retire at ${ageAtRetirement}.`
              : l.hint
          }
          onCommit={(v) => onChange({ ...value, [l.key]: v })}
        />
      ))}
    </fieldset>
  );
}
